import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { inject } from 'mobx-react'
import { Col, Button, Collapse, Icon } from 'antd'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import _get from 'lodash/get'
import _groupBy from 'lodash/groupBy'
import moment from 'moment'

@inject('i18n')
export default class EntryFee extends Component {
  render () {
    // console.log(this.props.fee)
    const {
      isRegOpen,
      dateTime,
      registrationTypes = [],
      priceSource,
      // location,
      ticketTypes = [],
      periods = [],
      slug,
      // liveLegacy,
      // website,
      customMessage,
      i18n
    } = this.props
    const { locale } = i18n
    let items = ticketTypes
    if (priceSource && priceSource === 'registration') {
      const regTypeItems = []
      registrationTypes.forEach(regType => {
        _get(regType, 'periodIds', []).forEach(periodId => {
          const item = {
            ...regType,
            periodId
          }
          regTypeItems.push(item)
        })
      })
      items = regTypeItems
    }
    const types = _groupBy(items, 'periodId')

    function toDate (time) {
      return moment(time).format('D MMMM YYYY')
    }
    // function toTime (time) {
    //   return moment(time).format('h.mm a')
    // }

    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // const beforeRegister = !periods.find(period => moment().isAfter(period.start))
    // const afterRegister = !periods.find(period => moment().isBefore(period.end))
    // console.log({ periods })

    // console.log({currentPeriod})

    // const preRegisterOpen = currentPeriod && currentPeriod.preRegister

    const $regUpcomingButton = (
      <Button
        type="primary"
        disabled
        style={{ margin: '16px', fontSize: '20px' }}
      >
        <FormattedMessage id="app.regUpcoming" defaultMessage="Registration Upcoming"/>
      </Button>
    )
    const $regClosedButton = (
      <Button
        type="primary"
        disabled
        style={{ margin: '16px', fontSize: '20px' }}
      >
        <FormattedMessage id="app.regClosed" defaultMessage="Registration Closed"/>
      </Button>
    )
    const $preRegisterButton = (
      <Link to={`/events/${slug}/register`} className="entryFeeRegistraterBtn">
        {{ en: 'Pre-Register', th: 'กรอกข้อมูลล่วงหน้า' }[locale]}
      </Link>
    )
    const $registerButton = (
      <Link to={`/events/${slug}/register`} className="entryFeeRegistraterBtn">
        <FormattedMessage id="app.register" defaultMessage="Register"/>
      </Link>
    )

    // const $liveLegacyWebsite = (
    //   <a href={website} className="entryFeeRegistraterBtn">
    //     <FormattedMessage id="app.register" defaultMessage="Register"/>
    //   </a>
    // )

    // console.log({ currentPeriod })
    return <Col md={{ span: 8, push: 16 }}>
      <div className="side_bar">
        <div className="no_pd">
          <div className="fee_title_line">
            <span className="title">
              <FormattedMessage id="app.entryFees" defaultMessage="Entry Fees" />
            </span>
          </div>
          {periods
            .filter(
              period => types[period._id] && types[period._id].length
            )
            .map(period => {
              // console.log({ period })
              // const periodTickets = _get(tickets, period._id, [])
              // if ()
              const isCurrent = moment().isBetween(period.start, period.end)
              const isPreRegister = moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
              const beforeRegister = moment().isBefore(period.start)
              const afterRegister = moment().isAfter(period.end)

              let $actionButton

              if (afterRegister) {
                $actionButton = $regClosedButton
              } else if (isPreRegister) {
                $actionButton = $preRegisterButton
              } else if (beforeRegister) {
                $actionButton = $regUpcomingButton
              } else if (isCurrent) {
                $actionButton = $registerButton
              } else if (!isRegOpen) {
                $actionButton = $regClosedButton
              }

              const ticketTypes = _get(types, period._id, []).sort((a, b) => a.order - b.order).filter(t => !t.hideOnFrontPage)
              if (ticketTypes.length === 0) {
                return <div />
              }

              return (
                <div key={period._id} style={{ borderTop: '1px solid grey', marginTop: '2em' }}>
                  <div className="period_box">
                    <span className="period">
                      {_get(period, ['name', locale])}
                    </span>
                    <p>
                      {moment(period.start).format('D MMM YYYY H.mm')}
                      {' '}
                        -
                      {' '}
                      {moment(period.end).format('D MMM YYYY H.mm')}
                      <br />
                      <FormattedMessage id="app.closeWhenFull" defaultMessage="or when fully registered" />
                    </p>
                  </div>
                  <Collapse bordered={false} style={{ background: 'none', color: 'white' }} onChange={console.log}>
                    <Collapse.Panel showArrow={false} style={{ border: 'none' }} header={
                      <React.Fragment>
                        <div className="ant-dropdown-link entryFeeBnt ant-dropdown-trigger">
                          <FormattedMessage
                            id="app.entryFee"
                            defaultMessage="Entry Fee"
                          />
                          <Icon type="down"/>
                        </div>
                      </React.Fragment>}
                    >
                      <table className="entryFee" >
                        <thead>
                          <tr>
                            <td>
                              <FormattedMessage
                                id="app.raceType"
                                defaultMessage="Race Type"
                              />
                            </td>
                            <td className="fee">
                              <FormattedMessage
                                id="app.entryFee"
                                defaultMessage="Entry Fee"
                              />
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {ticketTypes.map(ticketType => {
                            return (
                              <tr
                                key={ticketType._id}
                                className="entryFreeNameAndPrice"
                              >
                                <td >{_get(ticketType, ['name', locale])}</td>
                                <td className="fee">{<FormattedNumber value={ticketType.price} />} THB</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </Collapse.Panel>
                  </Collapse>
                  <div>
                    {$actionButton}
                  </div>
                </div>
              )
            })}
          {customMessage &&
            <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>{_get(customMessage, locale)}</div>
          }
          {/* <div className="comment">
              Open Register on
              <span>
                20 JUN 2015 - 20 JUL 2016
              </span>
            </div> */}
        </div>
      </div>
      <div className="side_bar">
        <span className="title">
          <FormattedMessage id="app.details" defaultMessage="Details" />
        </span>
        <div className="detailTitle">
          <FormattedMessage id="app.race_day" defaultMessag="Race Day" />
        </div>
        <div className="detailInfo">{toDate(dateTime)}</div>
        {/* <div className="detailTitle">
            Time
          </div>
          <div className="detailInfo">
            {toTime(dateTime)}
          </div>
          <div className="detailTitle">
            Location
          </div>
          <div className="detailInfo">
            {location}
          </div>
          */}
        {/* <div className="detailTitle">
            Organizer
          </div>
          <div className="detailInfo">
            Thai.run
          </div> */}
      </div>
    </Col>
  }
}



// WEBPACK FOOTER //
// ./src/App/EventPage/Components/EntryFee.js